import React from 'react';
import { Building2, Users, Clock, Banknote, Activity, Server, Database, Wifi } from 'lucide-react';
import { StatsCard } from '../../components/ui/StatsCard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { useAuth } from '../../contexts/AuthContext';
import { mockAuditLogs } from '../../data/mockData';
export function AdminDashboard() {
  const {
    currentUser
  } = useAuth();
  const pendingApprovals = [{
    id: 1,
    type: 'Branch',
    name: 'Sialkot Cantt',
    action: 'Create',
    date: '2024-03-15'
  }, {
    id: 2,
    type: 'User',
    name: 'Usman Ali',
    action: 'Modify',
    date: '2024-03-14'
  }, {
    id: 3,
    type: 'Branch',
    name: 'Multan Main',
    action: 'Modify',
    date: '2024-03-14'
  }];
  return <div className="space-y-6" data-id="element-205">
      {/* Welcome Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-206">
        <div data-id="element-207">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-208">
            Welcome back, {currentUser?.fullName}
          </h2>
          <p className="text-gray-500" data-id="element-209">
            Here's what's happening across the organization today.
          </p>
        </div>
        <div className="mt-4 md:mt-0" data-id="element-210">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800" data-id="element-211">
            <span className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-212"></span>
            System Operational
          </span>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-213">
        <StatsCard title="Total Branches" value="142" icon={Building2} trend="up" trendValue="+3 this month" color="green" data-id="element-214" />
        <StatsCard title="Active Users" value="856" icon={Users} trend="up" trendValue="+12 this week" color="blue" data-id="element-215" />
        <StatsCard title="Pending Approvals" value="18" icon={Clock} trend="neutral" trendValue="Same as yesterday" color="amber" data-id="element-216" />
        <StatsCard title="Today's Volume" value="PKR 45.2M" icon={Banknote} trend="down" trendValue="-5% vs avg" color="green" data-id="element-217" />
      </div>

      {/* System Health & Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-218">
        {/* System Health */}
        <Card title="System Health Status" className="lg:col-span-1" data-id="element-219">
          <div className="space-y-4" data-id="element-220">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-221">
              <div className="flex items-center" data-id="element-222">
                <Wifi className="w-5 h-5 text-green-600 mr-3" data-id="element-223" />
                <span className="font-medium text-gray-700" data-id="element-224">API Gateway</span>
              </div>
              <StatusBadge status="Active" size="sm" data-id="element-225" />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-226">
              <div className="flex items-center" data-id="element-227">
                <Activity className="w-5 h-5 text-green-600 mr-3" data-id="element-228" />
                <span className="font-medium text-gray-700" data-id="element-229">
                  RAAST Connection
                </span>
              </div>
              <StatusBadge status="Active" size="sm" data-id="element-230" />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-231">
              <div className="flex items-center" data-id="element-232">
                <Database className="w-5 h-5 text-green-600 mr-3" data-id="element-233" />
                <span className="font-medium text-gray-700" data-id="element-234">Core Database</span>
              </div>
              <StatusBadge status="Active" size="sm" data-id="element-235" />
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-236">
              <div className="flex items-center" data-id="element-237">
                <Server className="w-5 h-5 text-green-600 mr-3" data-id="element-238" />
                <span className="font-medium text-gray-700" data-id="element-239">File Storage</span>
              </div>
              <StatusBadge status="Active" size="sm" data-id="element-240" />
            </div>
          </div>
        </Card>

        {/* Recent Activity */}
        <Card title="Recent Audit Activity" className="lg:col-span-2" data-id="element-241">
          <div className="space-y-4" data-id="element-242">
            {mockAuditLogs.map(log => <div key={log.id} className="flex items-start space-x-3 pb-4 border-b border-gray-100 last:border-0 last:pb-0" data-id="element-243">
                <div className="w-2 h-2 mt-2 rounded-full bg-blue-500 flex-shrink-0" data-id="element-244"></div>
                <div data-id="element-245">
                  <p className="text-sm font-medium text-gray-900" data-id="element-246">
                    <span className="font-bold" data-id="element-247">{log.userName}</span> performed{' '}
                    <span className="text-blue-600" data-id="element-248">{log.action}</span>
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-249">
                    {new Date(log.timestamp).toLocaleString()} • {log.module}
                  </p>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* Pending Approvals Table */}
      <Card title="Pending Approvals" data-id="element-250">
        <DataTable columns={[{
        header: 'Type',
        accessor: 'type'
      }, {
        header: 'Entity Name',
        accessor: 'name'
      }, {
        header: 'Action',
        accessor: 'action'
      }, {
        header: 'Date',
        accessor: 'date'
      }, {
        header: 'Status',
        accessor: () => <StatusBadge status="ApprovalPending" size="sm" data-id="element-252" />
      }]} data={pendingApprovals} data-id="element-251" />
      </Card>
    </div>;
}